import * as accounting from 'accounting';

export default function (amount) {
  const formattedAmount = accounting.formatMoney(amount.amount, amount.symbol);
  return formattedAmount.replace(/\.00$/, '');
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/shared/format_amount.js